/* ==========================================================================
   Dida - melem 2 + 1: treći melem sam ulazi u košaricu (HR i RS, ista datoteka)

   ZAŠTO:
   Automatski popust "Dida Zvonko kaže: uzmi 2, treći je moj!" daje svaki
   treći melem gratis, ali ga ne stavlja u košaricu. 1.-2.10.2026. je 12 od
   18 kupaca koji su uzeli dva ili više melema stalo na točno dva, pa dar
   nisu dobili.

   KAKO:
   Kad je broj melema u košarici 2, 5, 8 ... i taj broj je narastao, skripta
   doda još jedan. Popust ga onda sam učini besplatnim. Ako kupac sam smanji
   s 3 na 2, broj nije narastao i skripta ga ne dira, pa nema natezanja.
   Zadnji viđeni broj stoji u localStorage. Bez njega skripta i dalje radi,
   samo bi nakon smanjenja na 2 i ponovnog učitavanja opet dodala treći.

   ZAŠTITA:
   Poslije dodavanja skripta pogleda košaricu. Ako popust nije dao dar (popust
   ugašen, istekao ili ga trgovina nema), vrati melem van prije nego što
   kupac išta vidi. Kupac nikad ne plati treći melem koji nije tražio.

   Košaricu mijenjaju gumb na proizvodu, ladica, stranica /cart i Selleasy
   skočni prozor, pa se skripta ne veže ni za jedan od njih. Sluša svaki
   fetch na /cart/add, /cart/change i /cart/update, i jednom pri učitavanju.
   ========================================================================== */

(function () {
  'use strict';

  var HANDLE = 'didin-melem-na-bazi-ricinusa-40ml';
  var KLJUC = 'dida-melem-dar';
  var izvorniFetch = window.fetch.bind(window);
  var radi = false;
  var opet = false;

  function procitaj() {
    try {
      var v = localStorage.getItem(KLJUC);
      return v === null ? null : parseInt(v, 10);
    } catch (e) {
      return null;
    }
  }

  function zapisi(n) {
    try {
      localStorage.setItem(KLJUC, String(n));
    } catch (e) {}
  }

  function json(url, tijelo) {
    var opcije = { credentials: 'same-origin' };
    if (tijelo) {
      opcije.method = 'POST';
      opcije.headers = { 'Content-Type': 'application/json' };
      opcije.body = JSON.stringify(tijelo);
    }
    return izvorniFetch(url, opcije).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function melemi(kosarica) {
    var m = { kolicina: 0, varijanta: null, cijena: 0, popust: 0, linija: null };
    kosarica.items.forEach(function (s) {
      if (s.handle !== HANDLE) return;
      m.kolicina += s.quantity;
      m.popust += s.original_line_price - s.final_line_price;
      m.cijena = s.original_price;
      if (!m.varijanta) m.varijanta = s.variant_id;
      if (!m.linija) m.linija = s;
    });
    return m;
  }

  function zamijeni(sekcije) {
    var ladica = document.querySelector('cart-drawer');
    var parser = new DOMParser();
    if (ladica && sekcije['cart-drawer']) {
      var novo = parser.parseFromString(sekcije['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      var staro = document.getElementById('CartDrawer');
      if (novo && staro) {
        staro.innerHTML = novo.innerHTML;
        ladica.classList.remove('is-empty');
        // Overlay je unutar #CartDrawer, pa zamjena briše njegov klik za zatvaranje.
        var overlay = ladica.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', ladica.close.bind(ladica));
      }
    }
    if (sekcije['cart-icon-bubble']) {
      var ikona = document.getElementById('cart-icon-bubble');
      var novaIkona = parser
        .parseFromString(sekcije['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (ikona && novaIkona) ikona.innerHTML = novaIkona.innerHTML;
    }
  }

  function osvjezi(sekcije) {
    // Stranica /cart ima svoje sekcije i ukupni iznos; najsigurnije je učitati je iznova.
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
    } else if (sekcije) {
      zamijeni(sekcije);
    }
  }

  // Vraća sekcije ladice i ikone ako je dar u košarici i besplatan, inače null.
  function dodaj(m) {
    return json(window.routes.cart_add_url + '.js', {
      items: [{ id: m.varijanta, quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    }).then(function (dodano) {
      if (!dodano) return null;
      return json(window.routes.cart_url + '.js').then(function (kosarica) {
        if (!kosarica) return null;
        var poslije = melemi(kosarica);
        if (poslije.popust >= Math.floor(poslije.kolicina / 3) * poslije.cijena) return dodano.sections || {};
        // Bez popusta Shopify ne dijeli stavku, pa je dodani melem u prvoj stavci.
        return json(window.routes.cart_change_url + '.js', {
          id: poslije.linija.key,
          quantity: poslije.linija.quantity - 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }).then(function (vraceno) {
          if (vraceno && vraceno.sections) zamijeni(vraceno.sections);
          return null;
        });
      });
    });
  }

  function provjeri() {
    if (radi) {
      opet = true;
      return;
    }
    radi = true;
    json(window.routes.cart_url + '.js')
      .then(function (kosarica) {
        if (!kosarica) return;
        var m = melemi(kosarica);
        var prije = procitaj();
        // Zapiši odmah: ako dodavanje ne uspije (nema zalihe, nema popusta), ne pokušavaj u krug.
        zapisi(m.kolicina);
        if (m.kolicina % 3 !== 2 || (prije !== null && m.kolicina <= prije)) return;
        return dodaj(m).then(function (sekcije) {
          if (!sekcije) return;
          zapisi(m.kolicina + 1);
          osvjezi(sekcije);
        });
      })
      .catch(function () {})
      .then(function () {
        radi = false;
        if (opet) {
          opet = false;
          provjeri();
        }
      });
  }

  // Tema poslije svake izmjene sama osvježi ladicu. Kad bi taj odgovor stigao
  // usred dodavanja dara, ladica bi pokazala krivo stanje. Zato skripta broji
  // tuđe zahtjeve prema košarici i krene tek kad svi završe.
  var uLetu = 0;

  function gotovo() {
    uLetu = Math.max(0, uLetu - 1);
  }

  function kadSeSmiri(fn, pokusaj) {
    pokusaj = pokusaj || 0;
    if (uLetu > 0 && pokusaj < 30) {
      setTimeout(function () {
        kadSeSmiri(fn, pokusaj + 1);
      }, 100);
    } else {
      fn();
    }
  }

  window.fetch = function (resurs, opcije) {
    var p = izvorniFetch(resurs, opcije);
    var url = typeof resurs === 'string' ? resurs : (resurs && resurs.url) || '';
    if (url.indexOf('/cart') !== -1) {
      uLetu++;
      p.then(function (r) {
        return r.clone().text();
      }).then(gotovo, gotovo);
    }
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function () {
        // 300 ms: za to vrijeme tema pokrene svoje osvježavanje ladice.
        setTimeout(function () {
          kadSeSmiri(provjeri);
        }, 300);
      }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', provjeri);
  } else {
    provjeri();
  }
})();
